import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudCheckboxModule,
	FreudLoaderModule,
	FreudPaginatorModule,
	FreudSelectModule,
	FreudTableModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactActionsMobileModule } from '../contact-actions-mobile/contact-actions-mobile.module';
import { ContactsTableComponent } from './contacts-table.component';

@NgModule({
	declarations: [ContactsTableComponent],
	imports: [
		CommonModule,
		FreudTableModule,
		FreudSelectModule,
		TranslateModule,
		FreudTooltipModule,
		FreudLoaderModule,
		FreudPaginatorModule,
		FormsModule,
		ContactActionsMobileModule,
		FreudCheckboxModule,
		FormsModule,
		FreudCheckboxModule,
	],
	exports: [ContactsTableComponent],
	providers: [],
})
export class ContactsTableModule {}
